import React, { useEffect, useRef } from 'react';

const SWEEP = 250; // degrees travelled while the section crosses the viewport

const BADGES = [
  {
    key: 'soc',
    tone: 'orb-sphere-deep',
    icon: 'fa-shield-halved',
    name: 'SOC 2',
    sub: 'Compliant',
    base: -120,
    label: 'SOC 2 compliant',
  },
  {
    key: 'hipaa',
    tone: 'orb-sphere-light',
    icon: 'fa-file-shield',
    name: 'HIPAA',
    sub: 'Compliant',
    base: 60,
    label: 'HIPAA compliant',
  },
];

const clamp01 = (n) => (n < 0 ? 0 : n > 1 ? 1 : n);

/* Two badges ride an orbit around the PHI core. Their angle is a pure
   function of how far the section has travelled through the viewport, so the
   motion is scrubbed by the scrollbar rather than played on a timer. */
const SecurityOrbit = () => {
  const wrapRef = useRef(null);
  const orbRefs = useRef([]);

  const setOrb = (i) => (el) => { orbRefs.current[i] = el; };

  useEffect(() => {
    const wrap = wrapRef.current;
    if (!wrap) return undefined;

    const reduced = window.matchMedia('(prefers-reduced-motion: reduce)');

    const apply = () => {
      const rect = wrap.getBoundingClientRect();
      // 0 as the section's top edge enters from below, 1 as its bottom leaves
      const span = window.innerHeight + rect.height;
      const p = reduced.matches ? 0.5 : clamp01((window.innerHeight - rect.top) / span);
      BADGES.forEach((b, i) => {
        const el = orbRefs.current[i];
        if (el) el.style.setProperty('--a', (b.base + p * SWEEP).toFixed(2));
      });
    };

    // Synchronous: animation frames do not run while the tab is unpainted.
    apply();
    window.addEventListener('scroll', apply, { passive: true });
    window.addEventListener('resize', apply);
    document.addEventListener('visibilitychange', apply);
    reduced.addEventListener?.('change', apply);

    return () => {
      window.removeEventListener('scroll', apply);
      window.removeEventListener('resize', apply);
      document.removeEventListener('visibilitychange', apply);
      reduced.removeEventListener?.('change', apply);
    };
  }, []);

  return (
    <div className="orb" ref={wrapRef}>
      <div className="orb-stage">
        <div className="orb-ring orb-ring-outer" aria-hidden="true"></div>
        <div className="orb-ring orb-ring-path" aria-hidden="true"></div>

        <a
          className="orb-cta btn btn-primary"
          href="https://trust.avenir.com.ai/"
          target="_blank"
          rel="noreferrer"
        >
          <i className="fa-solid fa-arrow-up-right-from-square" aria-hidden="true"></i>
          <span>Visit our Trust Center</span>
        </a>

        {BADGES.map((b, i) => (
          <div
            key={b.key}
            ref={setOrb(i)}
            className={`orb-sphere ${b.tone}`}
            style={{ '--a': b.base }}
          >
            <span className="orb-sphere-inner">
              <i className={`fa-solid ${b.icon}`} aria-hidden="true"></i>
              <span className="orb-sphere-name">{b.name}</span>
              <span className="orb-sphere-sub">{b.sub}</span>
            </span>
            <span className="sr-only">{b.label}</span>
          </div>
        ))}
      </div>
    </div>
  );
};

export default SecurityOrbit;
